/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { CartTenderLine } from '@msdyn365-commerce/retail-proxy';
import axios from 'axios';
/**
 * GetAuthTokenInput Input Action
 */
export interface ISubmitPaymentPayload {
    cartId: string,
    receiptEmail: string | undefined,
    cartTenderLines: CartTenderLine[] | undefined,
    cartVersion: number | undefined
}

export class WmapSubmitPaymentInput extends Msdyn365.CommerceEntityInput implements Msdyn365.IActionInput {

    public submitPaymentAPIurl: string | undefined;
    public submitPaymentPayload: ISubmitPaymentPayload | {};
    constructor(submitPaymentAPIurl: string | undefined, submitPaymentPayload: ISubmitPaymentPayload | {}) {
        super({ shouldCacheOutput: true, cacheObjectType: 'wmapauthorizepayment', cacheKey: 'wmapcapturepayment' });
        this.submitPaymentAPIurl = submitPaymentAPIurl;
        this.submitPaymentPayload = submitPaymentPayload;
    }

    public getCacheKey = () => `wmapcapturepayment`;
    public getCacheObjectType = () => 'wmapcapturepayment';
    public dataCacheType = (): Msdyn365.CacheType => 'request';

}

const createGetCardPaymentAcceptPointInput = (inputData: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>): Msdyn365.IActionInput => {
    if (inputData.config && inputData.config.submitPaymentAPIurl) {
        return new WmapSubmitPaymentInput(inputData.config.submitPaymentAPIurl, {});
    }
    return new WmapSubmitPaymentInput('', {});
};

// tslint:disable: no-any
export async function WmapSubmitPaymentAction(input: WmapSubmitPaymentInput, ctx: Msdyn365.IActionContext): Promise<any> {
    const apiResponseUrl = ctx.requestContext.apiSettings.baseUrl;
    const orderIdOun = ctx.requestContext.apiSettings.oun;
    try {
        const response = await axios.post(`${apiResponseUrl}${input.submitPaymentAPIurl}`,
            input.submitPaymentPayload
        , {
            headers: {
                // tslint:disable-next-line: object-literal-key-quotes
                'oun': orderIdOun,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (e) {
        // TODO: will be removed after unit test and deployment on lower environment
        console.log('Error for Submit Payment', e);
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<any>>WmapSubmitPaymentAction,
    input: createGetCardPaymentAcceptPointInput
});